// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-group[data-v-43221a13] {\n  min-height: 220px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 6px;\n  background: #fafafa;\n}\n.list-group-item[data-v-43221a13] {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  cursor: grab;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n", ""]);
// Exports
module.exports = exports;
